import { 
    CONVERT_MEDIA,
    } from '../actions/media'
import api from '@/utils/api'

const state = {
    isConverting: false,
    conversionsInProgress:{}
}

const getters = {
    getIsConverting: state => state.isUploading,
    getConversionsInProgress: state => state.conversionsInProgress
}
const actions = {
	[CONVERT_MEDIA]:({},fileDetails) => {
        console.log("CONVERT MEDIA!")
        let convertParams = {
            forComponent:fileDetails.forComponent,
            forRepository:fileDetails.forRepository,
            name:fileDetails.name
        }

        delete convertParams.file;
        delete convertParams.fromComponent;
        let url = 'convert-video'

        if(fileDetails.type.match("audio")){
            url = 'convert-audio'
        }
        
        api({ url: url, data:convertParams, method:"POST" })
    }
}

const mutations = {

}

export default {
	state,
	getters,
	actions,
	mutations,
}